import { useQsFilters } from "@dash/filters";

import { Serializers, SerializerValue } from "@megaron/serializers";
import { OrderDisplayFinancialStatus, OrderDisplayFulfillmentStatus } from "@megaron/shopify";

import { nonPalletDeliveryValues } from "./OrdersFilters";

export const ordersFiltersSerializer = Serializers.object({
  page: Serializers.integer.optional(),
  fulfillmentStatus: Serializers.string.array().asJsonString().optional(),
  financialStatus: Serializers.string.array().asJsonString().optional(),
  deliveryMethod: Serializers.string.array().asJsonString().optional(),
  isCancelled: Serializers.boolean.optional(),
}).partial();

export type OrdersFiltersType = SerializerValue<typeof ordersFiltersSerializer>;

export const useOrdersFilters = () => {
  const defaultFilters: OrdersFiltersType = {
    page: 0,
    fulfillmentStatus: [
      OrderDisplayFulfillmentStatus.PartiallyFulfilled,
      OrderDisplayFulfillmentStatus.Unfulfilled,
      OrderDisplayFulfillmentStatus.InProgress,
    ],
    financialStatus: [OrderDisplayFinancialStatus.Paid],
    deliveryMethod: nonPalletDeliveryValues,
    isCancelled: false,
  };

  const { filters, setFilters } = useQsFilters(ordersFiltersSerializer, defaultFilters);

  const setFilter =
    <K extends keyof OrdersFiltersType>(key: K) =>
    (value: OrdersFiltersType[K]) =>
      setFilters({ ...filters, [key]: value });

  return { filters, setFilter, setFilters, defaultFilters };
};
